import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { BaseComponent } from 'src/app/core/base.component';
import { SessionService } from 'src/app/shared/services/session.service';
import { Sponsor } from '../sponsor';
import { SponsorService } from '../sponsor.service';
import { StringHelpers } from 'src/app/shared/helpers/string-helpers';
import { getSponsorTypeLabel } from '../sponsor-type.helpers';

@Component({
  selector: 'app-sponsor-details',
  templateUrl: './sponsor-details.component.html',
  styleUrls: ['./sponsor-details.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class SponsorDetailsComponent extends BaseComponent implements OnInit {
  public id: string;
  public sponsor: Sponsor = new Sponsor();
  readonly getSponsorTypeLabel = getSponsorTypeLabel;

  constructor(
    public sessionService: SessionService,
    private route: ActivatedRoute,
    private sponsorService: SponsorService,
    stringHelpers: StringHelpers,
    private cdRef: ChangeDetectorRef
  ) {
    super(sessionService, stringHelpers);
  }

  ngOnInit(): void {
    if (this.isGlobalOutingSet()) {
      this.selectedIteration = this.getGlobalOutingIteration();
      this.id = this.route.snapshot.paramMap.get('id');
      this.getSponsorById();
    }
  }

  getSponsorById(): void {
    if (!this.id) {
      return;
    }
    this.isLoading = true;
    this.cdRef.markForCheck();
    this.sponsorService.getById(this.id).subscribe({
      next: (result) => {
        this.sponsor = result;
        this.isLoading = false;
        this.cdRef.markForCheck();
      },
      error: () => {
        this.isLoading = false;
        this.cdRef.markForCheck();
      }
    });
  }
}
